import { IModalElement } from "../service/modals";
import { videoPlayer } from "../app/video";
import { modalsService } from "./init";

export class FloridaEducatorsVideo implements IModalElement {
  public id = 'florida-educators-video';
  public maxWidth = 966;

  onInit() {
    videoPlayer(modalsService.content.querySelectorAll('.video-js'));
  }
}